import { Flex, Spinner } from '@radix-ui/themes'
import { Link } from '@tanstack/react-router'
import { PagingInfo, UsersItem } from '@/types/user'
import { useClassStore } from '@/stores/useClassStore'
import { cn } from '@/lib/utils'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import TablePaginate from '@/components/ui/table-paginate'
import { collumns, UserType } from '../constants'

const UsersTable = ({
  isLoading,
  meta,
  usersData,
  page,
  handlePageChange,
}: {
  isLoading: boolean
  meta: PagingInfo
  usersData: UsersItem[]
  page: number
  handlePageChange: (page: number) => void
}) => {
  const { setSelectedUserRole } = useClassStore()

  return (
    <div>
      <Table>
        <TableHeader className='bg-[#F6F7F9]'>
          <TableRow>
            {collumns.map((item) => (
              <TableHead
                key={item.title}
                style={{
                  width: item.width,
                }}
                className={cn('text-[#002652], font-bold')}
              >
                {item.title}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody className='text-[#002652]'>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={4}>
                <Flex justify={'center'}>
                  <Spinner size={'3'} />
                </Flex>
              </TableCell>
            </TableRow>
          ) : (
            <>
              {usersData?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} className='h-24 text-center'>
                    No data found.
                  </TableCell>
                </TableRow>
              )}
              {usersData?.map((item) => (
                <TableRow key={item.user_id}>
                  <TableCell className='w-[250px] max-w-[250px] min-w-[250px]'>
                    <p className='max-w-[250px] min-w-[250px] truncate'>
                      {item?.full_name ?? 'N/A'}
                    </p>
                    {!item.is_active && (
                      <div
                        className={cn(
                          'flex items-center gap-1 text-xs text-[#F04438]'
                        )}
                      >
                        <div
                          className={cn('size-1.5 rounded-full bg-[#F04438]')}
                        ></div>
                        Deleted user
                      </div>
                    )}
                  </TableCell>
                  <TableCell className='w-[140px] max-w-[140px] min-w-[140px] truncate'>
                    {item.username ?? 'N/A'}
                  </TableCell>
                  <TableCell className='w-[90px] max-w-[90px] capitalize'>
                    {item.role ?? 'N/A'}
                  </TableCell>
                  <TableCell className='max-w-[200px] truncate'>
                    {item.created_type
                      ? UserType[item.created_type as keyof typeof UserType]
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    <Link
                      to='/users/$studentId'
                      params={{ studentId: item.user_id.toString() }}
                      className='rounded px-3 py-2 text-[#0057B8] hover:bg-[#0057B8]/10'
                      onClick={() => setSelectedUserRole(item.role)}
                    >
                      View detail
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </>
          )}
        </TableBody>
      </Table>
      {meta && meta.total_pages > 1 && (
        <div className='flex justify-end p-4'>
          <TablePaginate
            itemPerPage={meta.items_per_page}
            totalItems={meta.total_items}
            page={page}
            totalPages={meta.total_pages}
            onPageChange={handlePageChange}
            readOnlyPageDisplay={false}
            hideOnSinglePage={false}
          />
        </div>
      )}
    </div>
  )
}

export default UsersTable
